import { aadhaarPattern, alphaNumericRegex, alphaNumericSpecialCharsRegex, alphaNumericWithoutSpace, emailRegex, onlyAlphaRegex, onlyDigital, onlyNumericRegex, panRegex, rcNumberRegex } from "./regex-patterns";

export const getRegexForValidation = (validationType: string) => {
    switch (validationType) {
        case "onlyAlpha":
            return {
                // value: /^[A-Za-z ]+$/,
                value : onlyAlphaRegex,
                message: "Please enter valid input"
            }
        case "email":
            return {
                value: emailRegex,
                message: "Not a valid Email",
            };
        case "pan":
            return {
                // value: /^[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$/i,
                value: panRegex,
                message: "Not a valid PAN",
            };
        case "rcNumber":
            return {
                // value: /^[A-Za-z]{2}[0-9]{2}[A-Za-z]{2}[0-9]{4}$/,
                value : rcNumberRegex,
                message: "Not a valid Vehicle Registration Number",
            };
        case "adhar":
            return {
                // value: /^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/,
                value: aadhaarPattern,
                message: "Not a valid Aadhar",
            };
        case "alphaNumeric":
            return {
                // value: /^[a-zA-Z0-9 ]+$/,
                value : alphaNumericRegex,
                message: "Please enter valid input",
            }
        case "OnlyNumeric":
            return {
                // value: /^\d+(\.\d+)?$/,
                value: onlyNumericRegex,
                message: "Please enter valid input",
            }
        case "onlyNumeric":
            return {
                // value: /^\d+(\.\d+)?$/,
                value: onlyNumericRegex,
                message: "Please enter valid input",
            }
        case "onlyDigital":
            return {
                // value: /^\d+$/,
                value : onlyDigital,
                message: "Please enter valid input",
            }
        case "alphaNumericSpecialChars":
            return {
                // value: /^[a-zA-Z0-9\s_.\-@$#+/&]+$/,
                value : alphaNumericSpecialCharsRegex,
                message: "Please enter valid input",
            }
        case "alphaNumericWithOutSpace":
            return {
                // value: /^[a-zA-Z0-9]*$/,
                value : alphaNumericWithoutSpace,
                message: "Spaces are not allowed",
            }
        default:
            return {
                value: /./,
                message: "",
            };
    }
};